import { Component, OnInit, DoCheck, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { StepDto } from '../../../../models/StepDTO';
import { NgForm } from '@angular/forms';
import { FileDto } from '../../../../models/FileDto';
import { FileInputComponent } from '../../../file-input/file-input.component';

@Component({
  selector: 'wdm-pdf-form',
  styleUrls: ['../../../../styles/components/steps.scss', 'pdf-form.component.scss'],
  templateUrl: 'pdf-form.component.html'
})
export class PDFFormComponent implements OnInit, DoCheck {


  @ViewChild('PDFForm', { static: true }) private PDFForm: NgForm;
  @Input() stepInfo: StepDto;
  @Output() errors: EventEmitter<boolean> = new EventEmitter<boolean>(true);
  isRequired = false;
  isMaxSize = false;
  pdfFiles: FileDto[] = [];
  fileInputErrors: boolean;
  @ViewChild(FileInputComponent) fileInputComponent: FileInputComponent;


  constructor() {
  }

  ngOnInit() {
    this.pdfFiles = this.stepInfo.fileList;
  }

  ngDoCheck(): void {
    if (this.PDFForm.status === 'INVALID' || this.fileInputErrors == true) {
      this.errors.emit(true);
    } else {
      this.stepInfo.state = "OK";
      this.errors.emit(false);
    }
  }

  forceValidation() {
    this.PDFForm.controls.title.markAsTouched();
    this.PDFForm.controls.description.markAsTouched();
    if (this.stepInfo.fileList.length == 0) {
      this.fileInputComponent.showError();
    }
    this.PDFForm.controls.pageNumber.markAsTouched();
  }

  onFileChanges(inputFiles) {
    this.stepInfo.fileList = this.pdfFiles;
  }

  hasErrors(hasErrors: boolean): void {
    this.fileInputErrors = hasErrors;
  }
}
